'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var URL = require('url-parse');

var MAX_SIZE = 64 * 1024; // 64kb

var DELIMITER = '\r\n'; // TODO: rename and refactor to support Node
// TODO: flush more often

var BrowserExporter =
/*#__PURE__*/
function () {
  function BrowserExporter(_ref) {
    var _this = this;

    var clientToken = _ref.clientToken,
        url = _ref.url,
        site = _ref.site,
        env = _ref.env;

    _classCallCheck(this, BrowserExporter);

    this._queue = [];
    this._flushing = false;
    this._clientToken = clientToken;
    this._env = env;
    this._url = url || new URL("https://public-trace-http-intake.logs.".concat(site));
    this._size = 0;
    window.addEventListener('beforeunload', function () {
      return _this._flush();
    });
    window.addEventListener('visibilitychange', function () {
      return _this._flush();
    });
  }

  _createClass(BrowserExporter, [{
    key: "export",
    value: function _export(spans) {
      var meta = this._traceMeta();

      var json = JSON.stringify({
        spans: spans,
        meta: meta
      });
      var size = json.length + (this._queue.length > 0 ? DELIMITER.length : 0);

      if (this._size + size > MAX_SIZE) {
        if (this._flushing) return; // drop trace to avoid multiple connections

        if (size > MAX_SIZE) return; // drop trace because too large

        this._flush();
      }

      this._size += size;

      this._queue.push(json);
    }
  }, {
    key: "_flush",
    value: function _flush() {
      var _this2 = this;

      if (this._queue.length === 0) return;
      this._flushing = true;
      var url = "".concat(this._url.href, "/v1/input/").concat(this._clientToken);

      var body = this._queue.join(DELIMITER);

      this._queue = [];
      this._size = 0;
      send(url, body, function () {
        _this2._flushing = false;
      });
    }
  }, {
    key: "_traceMeta",
    value: function _traceMeta() {
      var meta = {
        '_dd.source': 'browser'
      };
      addTag(meta, 'env', this._env);
      return meta;
    }
  }]);

  return BrowserExporter;
}();

function send(url, body, callback) {
  if (window.navigator && window.navigator.sendBeacon) {
    window.navigator.sendBeacon(url, body);
  } else if (window.fetch) {
    window.fetch(url, {
      body: body,
      method: 'POST',
      keepalive: true,
      mode: 'no-cors'
    }).then(callback, callback);
  } else {
    var req = new XMLHttpRequest();
    req.open('POST', url, true);
    req.addEventListener('loadend', callback);
    req.send(body);
  }
}

function addTag(meta, key, value) {
  if (!value) return;
  meta[key] = value;
}

module.exports = BrowserExporter;